import Vue from "vue"
import settings from "@/settings.coffee"


export default {
    # schema: (params)->
    #     return """
    #     query{__schema{types{
    #         name
    #         description
    #         fields {
    #             description
    #             deprecationReason
    #             name
    #         }
    #     }}}
    #     """
    get_vp_type_set: (company_uid)->
        return """
        query{vp_type_set(company_uid:\"#{company_uid}\"){
            uid
            name
        }}
        """
    get_vp_code_set: (company_uid)->
        return """
        query{vp_code_set(company_uid:\"#{company_uid}\"){
            uid
            value
        }}
        """
    get_vp_userjob_set: (company_uid, date, component, period)->
        # console.log "GET_VP_DATED_USER_JOB_SET", company_uid, date, component
        return """
        query{vp_userjob_set(company_uid:\"#{company_uid}\", date:\"#{date}\", component:\"#{component}\", period: \"#{period}\"){
            uid
            user{
                user_info{
                    lastname
                    firstname
                }
            }
            job{
                name
            }
            vp_dated_user_job{
                uid
                state{
                    uid
                    label
                    slug
                }
                reason
                file_url
                sent
                sending_date
                transmission_date
                vp_dated{
                    date
                }
                vp_element_set_group{
                    vp_custom_vp_dated_uid
                    element_set{
                        uid
                        value
                        date
                        file_url
                    }
                }
            }
            start
        }}
        """
    get_vp_custom_vp_dated_set: (company_uid, date)->
        # console.log "GET_VP_CUSTOM_VP_DATED_SET", company_uid, date
        return """
        query{vp_custom_vp_dated_set(company_uid:\"#{company_uid}\", date:\"#{date}\"){
            uid
            vp_custom{
                uid
                name
                editable_by_all
            }
        }}
        """
    get_vpc_set: (company_uid)->
        # console.log "GET_VPC_SET", company_uid
        return """
        query{variable_payroll_custom_set(company_uid:\"#{company_uid}\"){
            uid
            name
            editable_by_all
            vp_custom_vp_dated_set{
                uid
            }
            vp_code{
                uid
                value
            }
            vp_type{
                uid
                name
                slug
            }
        }}
        """
    get_vpe_absence_set: (company_uid, date)->
        # console.log "GET_VPE_ABSENCE_SET", company_uid, date
        return """
        query{vpe_absence_set(company_uid:\"#{company_uid}\", date:\"#{date}\"){
            user_str
            value
            absence_type{
                label
                group
            }
            start
            start_day_part
            end
            end_day_part
        }}
        """
    get_variable_payroll_params: (company_uid, date)->
        # console.log "GET_VARIABLE_PAYROLL_PARAMS", company_uid, date
        return """
        query{variable_payroll_params(company_uid:\"#{company_uid}\", date:\"#{date}\"){
            uid
            max_date_delta
            sending_day
        }}
        """
    get_accounting_software_company_link: (company_uid)->
        # console.log "GET_ACCOUNTING_SOFTWARE_COMPANY_LINK", company_uid
        return """
        query{accounting_software_company_link(company_uid:\"#{company_uid}\"){
            uid
            api_url
            api_client_login
            api_user_login
            intermediary
            comment
            accounting_software{
                uid
                name
            }
            axis
            as_import_item_params_set{
                uid
                as_import_item{
                    uid
                    name
                    slug
                }
                automatic
                last_update
                log
            }
            user_connection
        }}
        """
    get_accounting_software_set: ()->
        # console.log "GET_ACCOUNTING_SOFTWARE_SET"
        return """
        query{accounting_software_set{
            uid
            name
        }}
        """
    get_balance: (user_uid)->
        # console.log "GET BALANCE"
        return """
        query{balance(user_uid:\"#{user_uid}\"){
            uid
            modified
            leave_n_1{
                label
                acquired
                taken
                wage_balance
                validated_days
                rh_balance
            }
            leave_n{
                label
                acquired
                taken
                wage_balance
                validated_days
                rh_balance
            }
            seniority_leave{
                label
                acquired
                taken
                wage_balance
                validated_days
                rh_balance
            }
            extra_leave_1{
                label
                acquired
                taken
                wage_balance
                validated_days
                rh_balance
            }
            extra_leave_2{
                label
                acquired
                taken
                wage_balance
                validated_days
                rh_balance
            }
            total_leave{
                label
                acquired
                taken
                wage_balance
                validated_days
                rh_balance
            }
            rtt{
                label
                acquired
                taken
                wage_balance
                validated_days
                rh_balance
            }
            rco{
                label
                acquired
                taken
                wage_balance
                validated_days
                rh_balance
            }
            rcr{
                label
                acquired
                taken
                wage_balance
                validated_days
                rh_balance
            }
            total_rc{
                label
                acquired
                taken
                wage_balance
                validated_days
                rh_balance
            }
            cet{
                label
                acquired
                taken
                wage_balance
                validated_days
                rh_balance
            }
            break_days{
                label
                acquired
                taken
                wage_balance
                validated_days
                rh_balance
            }
        }}
        """

    get_type_set: (type_name)->
        return"""
        query{#{type_name}_set{
            uid
            label
            slug
        }}
        """

    get_absence_choice_set: ()->
        return"""
        query{absence_choice_set{
            uid
            group
            label
            slug
        }}
        """

    get_ged_set: (company_uid, user_uid, folder_uid)->
        return"""
        query{ged_set(company_uid:\"#{company_uid}\", user_uid:\"#{user_uid}\", folder_uid:\"#{folder_uid}\"){
            uid
            name
            size
            modified
            type_label
            editable
            private
            link
        }}
        """

    get_import_configuration_set: (company_uid, item)->
        return"""
        query{import_configuration_set(company_uid:\"#{company_uid}\", item:\"#{item}\"){
            uid
            item
            name
            ignore_lines
            fields
        }}
        """

    get_import_set: (company_uid, item)->
        return"""
        query{import_set(company_uid:\"#{company_uid}\", item:\"#{item}\"){
            uid
            user{
                uid
                fullnamejobs
                user_info{
                    firstname
                    lastname
                }
            }
            item
            is_utf8
            separator
            delete_all
            csv
            csv_dir
            created
            modified
        }}
        """

    get_calendar_event_set: (company_uid, establishments_uids, event_types, users_uids, with_subordinates, start, end)->
        return"""
        query{calendar_event_set(
            company_uid:\"#{company_uid}\",
            establishments_uids:#{JSON.stringify(establishments_uids)},
            event_types:#{JSON.stringify(event_types)},
            users_uids:#{JSON.stringify(users_uids)},
            with_subordinates:#{with_subordinates},
            start:\"#{start.split('T')[0]}\", 
            end:\"#{end.split('T')[0]}\"
        ){
            title
            allDay
            start
            end
            extendedProps{
                item_type
                item_uid
                date_str
                user_uid
                user_fullnamejobs
                asked_user_fullnamejobs
            }
            color
            editable
            droppable
        }}
        """

    get_dashboard_alert_set: (company_uid, user_uid)->
        return """
        query{dashboard_alert_set(company_uid:\"#{company_uid}\", user_uid:\"#{user_uid}\"){
            absences_count
            formations_count
            interviews_count
        }}
        """        

    get_election: (company_uid)->
        return """
        query{election(company_uid:\"#{company_uid}\"){
            uid
            employees
            done
            last_election
            next_election
        }}
        """

    get_company_custom_skill_set: (company_uid)->
        return """
        query{company_custom_skill_set(company_uid:\"#{company_uid}\"){
            uid
            name
            slug
        }}
        """

    get_user_custom_skill_set: (user_uid)->
        return """
        query{user_custom_skill_set(user_uid:\"#{user_uid}\"){
            uid
            skill{
                uid
                name
                slug
            }
        }}
        """

    get_campaign_set: (company_uid)->
        return """
        query{interview_campaign_set(company_uid:\"#{company_uid}\"){
            uid
            name
            campaign_type
            user{
                uid
                fullnamejobs
                user_info{
                    firstname
                    lastname
                }
            }
            start
            end
            user_doc
            user_doc_dir
            manager_doc
            manager_doc_dir
            manager_final_doc
            manager_final_doc_dir
            complete_filename
        }}
        """

    get_interview_coming_set: ()->
        return """
        query{interview_coming_set{
            uid
            with_who
            interview_type{
                uid
                label
                slug
            }
            datetime
            datetime_str
        }}
        """

    get_interview_file_set: (interview_uid, component)->
        return """
        query{interview_file_set(interview_uid:\"#{interview_uid}\", component:\"#{component}\"){
            uid
            name
            filename
            filename_dir
            filesize
            filetype
            complete_filename
        }}
        """

    get_interview_set: (company_uid, component)->
        return """
        query{interview_set(company_uid:\"#{company_uid}\", component:\"#{component}\"){
            uid
            user_str
            asked_user_str
            asked_user_uid
            interview_type{
                uid
                label
                slug
            }
            files
            datetime
            datetime_str
            state{
                uid
                label
                slug
            }
            reason
        }}
        """

    get_pro_hazard_set: (company_uid, component)->
        return """
        query{pro_hazard_set(company_uid:\"#{company_uid}\", component:\"#{component}\"){
            uid
            file
            file_dir
            modified
            complete_filename
            date
            file_url
        }}
        """

    get_formation_set: (company_uid, component)->
        return"""
        query{formation_set(company_uid:\"#{company_uid}\", component:\"#{component}\"){
            uid
            user_str
            user_in_charge_str
            formation_type{
                uid
                label
                slug
            }
            start
            end
            state{
                uid
                label
                slug
            }
            reason
            program
            program_dir
            name
            duration
            duration_unity
            location
            organization
            funding{
                uid
                label
                slug
            }
            complete_filename
        }}
        """

    get_oncall_duty_set: (company_uid, component)->
        return """
        query{oncall_duty_set(company_uid:\"#{company_uid}\", component:\"#{component}\"){
            uid
            file
            file_dir
            modified
            complete_filename
        }}
        """

    # ## Deprecated after Holiday and Absence fusion
    # get_absence_set: (company_uid, component)->
    #     return"""
    #     query{absence_set(company_uid:\"#{company_uid}\", component:\"#{component}\"){
    #         uid
    #         user_str
    #         user_in_charge_str
    #         absence_type{
    #             uid
    #             label
    #             slug
    #         }
    #         start
    #         end
    #         state{
    #             uid
    #             label
    #             slug
    #         }
    #         reason
    #         proof
    #         proof_dir
    #         complete_filename
    #     }}
    #     """

    get_absence_set: (company_uid, component)->
        return"""
        query{absence_set(company_uid:\"#{company_uid}\", component:\"#{component}\"){
            uid
            user_str
            user_uid
            user_in_charge_str
            absence_type{
                uid
                label
                slug
                group
            }
            start
            start_day_part
            end
            end_day_part
            nb_days
            state{
                uid
                label
                slug
            }
            reason
        }}
        """

    get_graduate_set: (user_uid)->
        return"""
        query{graduate_set(user_uid:\"#{user_uid}\"){
            uid
            name
            validated
            obtainment_str
            validity_duration
            validity_end
            level{
                uid
                label
                slug
            }
            graduate_type{
                uid
                label
                slug
            }
            file
            file_dir
            complete_filename
        }}
        """

    get_payslip_set: (user_uid)->
        return"""
        query{pay_slip_set(user_uid:\"#{user_uid}\"){
            uid
            date
            file
            file_dir
            complete_filename
        }}
        """

    get_salary_set: (user_uid)->
        return"""
        query{salary_set(user_uid:\"#{user_uid}\"){
            uid
            bonus
            base
            period
            evolution
        }}
        """

    get_skill_user_job_set: (user_uid)->
        return"""
        query{skill_user_job_set(user_uid:\"#{user_uid}\"){
            uid
            job{
                uid
                name
            }
        }}
        """

    get_userjob_set: (user_uid)->
        return"""
        query{user_job_set(user_uid:\"#{user_uid}\"){
            uid
            step
            level{
                uid
                label
                slug
            }
            contract_type{
                uid
                label
                slug
            }
            status{
                uid
                label
                slug
            }
            weekly_hours
            coefficient
            partial_time
            notice_duration_unity
            trial_duration_unity
            notice_duration
            trial_duration
            renew_trial
            start
            end
            establishments{
                uid
                name
            }
            job{
                uid
                name
            }
            service_name
            employer_name
            employer_address
            organization_name
            tutor_name
            idcc
            reference
            interviews
            file
            file_dir
            complete_filename
        }}        
        """

    get_voucher_set: (user_uid)->
        return """
        query{voucher_set(user_uid:\"#{user_uid}\"){
            uid
            name
            file
            file_dir
            modified
            complete_filename
        }}
        """

    get_user_presence_stat: ()->
        return """
        query{user_presence_stat{
            month
            year
            count
            days{
                day
                count
            }
        }}
        """

    get_distribution_set: (company_uid)->
        # console.log "GET DISTRIBUTIONS", company_uid
        return """
        query{distribution_set(company_uid:\"#{company_uid}\"){
            uid
            company{
                uid
                name
                reference
                ape_naf_code
                siret
                logo
                logo_dir
                city
                is_active
                accounting_software_company_link_set{
                    accounting_software{
                        slug
                    }
                }
                has_accounting_software
                has_vpc_to_bind
            }
            is_distributor
            distributed_by{
                uid
                company{
                    uid
                    name
                    reference
                    ape_naf_code
                    siret
                    logo
                    logo_dir
                    city
                    is_active
                    accounting_software_company_link_set{
                        accounting_software{
                            slug
                        }
                    }
                    has_accounting_software
                    has_vpc_to_bind
                }
            }
            white_label
            logo
            admin_email
            children{
                uid
                distributed_by{
                    uid
                    company{
                        uid
                        name
                    }
                }
                company{
                    uid
                    name
                    reference
                    ape_naf_code
                    siret
                    logo
                    logo_dir
                    city
                    is_active
                    accounting_software_company_link_set{
                        accounting_software{
                            slug
                        }
                    }
                    has_accounting_software
                    has_vpc_to_bind
                }
                is_distributor
                children{
                    uid
                    distributed_by{
                        uid
                        company{
                            uid
                            name
                        }
                    }
                    company{
                        uid
                        name
                        reference
                        ape_naf_code
                        siret
                        logo
                        logo_dir
                        city
                        is_active
                        accounting_software_company_link_set{
                            accounting_software{
                                slug
                            }
                        }
                        has_accounting_software
                        has_vpc_to_bind
                    }
                    is_distributor
                    children{
                        uid
                        distributed_by{
                            uid
                            company{
                                uid
                                name
                            }
                        }
                        company{
                            uid
                            name
                            reference
                            ape_naf_code
                            siret
                            logo
                            logo_dir
                            city
                            is_active
                            accounting_software_company_link_set{
                                accounting_software{
                                    slug
                                }
                            }
                            has_accounting_software
                            has_vpc_to_bind
                        }
                        is_distributor
                        children{
                            uid
                            distributed_by{
                                uid
                                company{
                                    uid
                                    name
                                }
                            }
                            company{
                                uid
                                name
                                reference
                                ape_naf_code
                                siret
                                logo
                                logo_dir
                                city
                                is_active
                                accounting_software_company_link_set{
                                    accounting_software{
                                        slug
                                    }
                                }
                                has_accounting_software
                                has_vpc_to_bind
                            }
                            is_distributor
                            children{
                                uid
                                distributed_by{
                                    uid
                                    company{
                                        uid
                                        name
                                    }
                                }
                                company{
                                    uid
                                    name
                                    reference
                                    ape_naf_code
                                    siret
                                    logo
                                    logo_dir
                                    city
                                    is_active
                                    accounting_software_company_link_set{
                                        accounting_software{
                                            slug
                                        }
                                    }
                                    has_accounting_software
                                    has_vpc_to_bind
                                }
                                is_distributor
                            }
                        }
                    }
                }
            }
        }}
        """

    get_tree: (company_uid)->
        # console.log "GET TREE", company_uid
        return """
        query{tree(company_uid:\"#{company_uid}\"){
            uid
            parent_uid
            fullname
            fullnamejobs
            user_info{
                firstname
                lastname
            }
            level
            position
            is_activated
            is_archived
            is_active
            editable
            is_manager
            roles{
                uid
                name
            }
            establishments
            subordinates{
                uid
                parent_uid
                fullname
                fullnamejobs
                user_info{
                    firstname
                    lastname
                }
                level
                position
                is_activated
                is_archived
                is_active
                editable
                is_manager
                roles{
                    uid
                    name
                }
                establishments
                subordinates{
                    uid
                    parent_uid
                    fullname
                    fullnamejobs
                    user_info{
                        firstname
                        lastname
                    }
                    level
                    position
                    is_activated
                    is_archived
                    is_active
                    editable
                    is_manager
                    roles{
                        uid
                        name
                    }
                    establishments
                    subordinates{
                        uid
                        parent_uid
                        fullname
                        fullnamejobs
                        user_info{
                            firstname
                            lastname
                        }
                        level
                        position
                        is_activated
                        is_archived
                        is_active
                        editable
                        is_manager
                        roles{
                            uid
                            name
                        }
                        establishments
                        subordinates{
                            uid
                            parent_uid
                            fullname
                            fullnamejobs
                            user_info{
                                firstname
                                lastname
                            }
                            is_activated
                            is_archived
                            is_active
                            editable
                            is_manager
                            roles{
                                uid
                                name
                            }
                            establishments
                            subordinates{
                                uid
                                parent_uid
                                fullname
                                fullnamejobs
                                user_info{
                                    firstname
                                    lastname
                                }
                                is_activated
                                is_archived
                                is_active
                                editable
                                is_manager
                                roles{
                                    uid
                                    name
                                }
                                establishments
                                subordinates{
                                    uid
                                    parent_uid
                                    fullname
                                    fullnamejobs
                                    user_info{
                                        firstname
                                        lastname
                                    }
                                    is_activated
                                    is_archived
                                    is_active
                                    editable
                                    is_manager
                                    roles{
                                        uid
                                        name
                                    }
                                    establishments
                                    subordinates{
                                        uid
                                        parent_uid
                                        fullname
                                        fullnamejobs
                                        user_info{
                                            firstname
                                            lastname
                                        }
                                        is_activated
                                        is_archived
                                        is_active
                                        editable
                                        is_manager
                                        roles{
                                            uid
                                            name
                                        }
                                        establishments
                                        subordinates{
                                            uid
                                            parent_uid
                                            fullname
                                            fullnamejobs
                                            user_info{
                                                firstname
                                                lastname
                                            }
                                            is_activated
                                            is_archived
                                            is_active
                                            editable
                                            is_manager
                                            roles{
                                                uid
                                                name
                                            }
                                            establishments
                                            subordinates{
                                                uid
                                                parent_uid
                                                fullname
                                                fullnamejobs
                                                user_info{
                                                    firstname
                                                    lastname
                                                }
                                                is_activated
                                                is_archived
                                                is_active
                                                editable
                                                is_manager
                                                roles{
                                                    uid
                                                    name
                                                }
                                                establishments
                                                subordinates{
                                                    uid
                                                    parent_uid
                                                    fullname
                                                    fullnamejobs
                                                    user_info{
                                                        firstname
                                                        lastname
                                                    }
                                                    is_activated
                                                    is_archived
                                                    is_active
                                                    editable
                                                    is_manager
                                                    roles{
                                                        uid
                                                        name
                                                    }
                                                    establishments
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }}
        """
    get_company: (company_uid)->
        # console.log "GET COMPANY", company_uid
        return """
        query{company(company_uid:\"#{company_uid}\"){
            uid
            legal_form{
                uid
            }
            reference
            name
            ape_naf_code
            siret
            employees_nb
            address
            address2
            zipcode
            city
            phone
            email
            logo
            logo_dir
            opco
            opco_member_number
            opco_address
            opco_address2
            opco_zipcode
            opco_city
            opco_link
            medical
            medical_member_number
            medical_address
            medical_address2
            medical_zipcode
            medical_city
            medical_link
            voluntary_contribution
            voluntary_contribution_amount
            distribution{
                uid
                is_distributor
                distributed_by_uid
                white_label
                distribution_logo
                distribution_logo_dir
                admin_email
            }
            accounting_software_company_link_set{
                accounting_software{
                    slug
                }
            }
            has_accounting_software
            has_vpc_to_bind
        }}
        """
    get_company_stats: (company_uid)->
        return """
        query{company(company_uid:\"#{company_uid}\"){
            stats{
                employee_nb
                dirigeant_profile_nb
            }
        }}
        """
    get_contact_opco_set: (company_uid)->
        # console.log "GET Contact_OPCO"
        return """
        query{contact_opco_set(company_uid:\"#{company_uid}\"){
            uid
            company_uid
            firstname
            lastname
            phone
            email
        }}
        """
    get_contact_medical_set: (company_uid)->
        # console.log "GET Contact_Medical"
        return """
        query{contact_medical_set(company_uid:\"#{company_uid}\"){
            uid
            company_uid
            firstname
            lastname
            phone
            email
        }}
        """
    get_establishment: (establishment_uid)->
        # console.log "GET ONE ESTABLISHMENT"
        return """
        query{establishment(establishment_uid:\"#{establishment_uid}\"){
            uid
            company_uid
            name
            siret
            address
            address2
            zipcode
            city
            phone
            email
        }}
        """
    get_users_jobs_establishment_set: (company_uid, user_uid)->
        # console.log "GET ESTABLISHMENTS"
        return """
        query{users_jobs_establishment_set(company_uid:\"#{company_uid}\", user_uid:\"#{user_uid}\"){
            uid
            company_uid
            name
        }}
        """
    get_establishment_set: (company_uid)->
        # console.log "GET ESTABLISHMENTS"
        return """
        query{establishment_set(company_uid:\"#{company_uid}\"){
            uid
            company_uid
            name
            siret
            address
            address2
            zipcode
            city
            phone
            email
        }}
        """
    get_job: (job_uid)->
        # console.log "GET ONE JOB"
        return """
        query{job(job_uid:\"#{job_uid}\"){
            uid
            company_uid
            name
            definition
            graduate_level{
                uid
            }
            graduate_mandatory
        }}
        """
    get_users_jobs_job_set: (company_uid, user_uid)->
        # console.log "GET JOBS"
        return """
        query{users_jobs_job_set(company_uid:\"#{company_uid}\", user_uid:\"#{user_uid}\"){
            uid
            name
            graduate_level{
                uid
                label
                slug
            }
        }}
        """
    get_recruitments_job_set: (company_uid)->
        # console.log "GET JOBS"
        return """
        query{recruitments_job_set(company_uid:\"#{company_uid}\"){
            uid
            name
            graduate_level{
                uid
                label
                slug
            }
        }}
        """
    get_job_set: (company_uid)->
        # console.log "GET JOBS"
        return """
        query{job_set(company_uid:\"#{company_uid}\"){
            uid
            name
            graduate_level{
                uid
                label
                slug
            }
        }}
        """
    get_app_user_job_set: (user_uid)->
        # console.log "GET JOBS"
        return """
        query{app_user_job_set(user_uid:\"#{user_uid}\"){
            uid
            name
        }}
        """
    get_recruitment: (recruitment_uid)->
        # console.log "GET ONE RECRUITMENT"
        return """
        query{recruitment(recruitment_uid:\"#{recruitment_uid}\"){
            uid
            job{
                uid
                name
            }
            content
            experience_level{
                uid
            }
            experience_mandatory
            experience_domains
            graduate_level{
                uid
            }
            graduate_mandatory
            graduate_domains
            pay_from
            pay_to
            bonus
            advantages
            status{
                uid
            }
            context
            days_variable
            hours_variable
            location
            trips_frequency
            trips_zone
            active
            created
        }}
        """      
    get_recruitment_set: (company_uid)->
        # console.log "GET RECRUITMENTS"
        return """
        query{recruitment_set(company_uid:\"#{company_uid}\"){
            uid
            job{
                uid
                name
            }
            content
            experience_level{
                uid
                label
                slug
            }
            experience_mandatory
            experience_domains
            graduate_level{
                uid
                label
                slug
            }
            graduate_mandatory
            graduate_domains
            pay_from
            pay_to
            bonus
            advantages
            status{
                uid
                label
                slug
            }
            context
            days_variable
            hours_variable
            location
            trips_frequency
            trips_zone
            active
            created
        }}
        """        
    get_company_skill_set: (company_uid, skills_types)->
        # console.log "GET SKILLS"
        st = "["
        count = skills_types.length
        # console.log "COUNT", count
        for v, i in skills_types
            st += "\""+v+"\""
            if i != count-1
                st += ','
        st += "]"
        return """
        query{company_skill_set(company_uid:\"#{company_uid}\", skills_types:#{st}){
            uid
            name
            user_skill_set{
                level
                level_custom
                user{
                    uid
                    fullnamejobs
                    editable
                    user_info{
                        firstname
                        lastname
                    }
                }
            }
        }}
        """
    get_job_skill_set: (job_uid)->
        # console.log "GET SKILLS"
        return """
        query{job_skill_set(job_uid:\"#{job_uid}\"){
            uid
            skill_type
            name
            slug
            level_waited
            mandatory
            tasks{
                uid
                skill_type
                name
                slug
                level_waited
                mandatory
            }
        }}
        """
    get_recruitments_job_skill_set: (job_uid)->
        # console.log "GET SKILLS"
        return """
        query{recruitments_job_skill_set(job_uid:\"#{job_uid}\"){
            uid
            skill_type
            name
            slug
            level_waited
            mandatory
            tasks{
                uid
                skill_type
                name
                slug
                level_waited
                mandatory
            }
        }}
        """
    get_app_user_job_skill_set: (user_uid, job_uid)->
        # console.log "GET SKILLS"
        return """
        query{app_user_job_skill_set(user_uid:\"#{user_uid}\", job_uid:\"#{job_uid}\"){
            uid
            skill_type
            name
            slug
            level_waited
            tasks{
                uid
                skill_type
                name
                slug
                level_waited
                app_user_user_skill{
                    uid
                    level
                }
                evaluation_set{
                eval_uid
                user_skill_uid
                user_skill_level
                user_skill_minimal_level_waited

            }
            }
            app_user_user_skill{
                uid
                level
            }
            evaluation_set{
                eval_uid
                user_skill_uid
                user_skill_level
                user_skill_minimal_level_waited

            }
        }}
        """
    get_user: (user_uid)->
        # console.log "GET USER", user_uid
        return """
        query{app_user(user_uid:\"#{user_uid}\"){
            uid
            parent{
                uid
            }
            roles{
                uid
                name
            }
            email
            ical
            is_activated
            is_archived
            is_active
            user_info{
                uid
                gender
                lastname
                firstname
                birthday
                nationality
                title_of_stay
                title_of_stay_name
                title_of_stay_number
                title_of_stay_validity
                address
                address2
                zipcode
                city
                phone
                social_nbr
                medical_visit
                sir
                rqth
                rqth_end
                photo
                photo_dir
                opco
                reference
            }
        }}
        """
    get_archived_user_set: (company_uid)->
        # console.log "GET ARCHIVED USER SET", company_uid
        return """
        query{archived_user_set(company_uid:\"#{company_uid}\"){
            uid
            parent_uid
            roles{
                uid
                name
            }
            email
            ical
            is_activated
            is_archived
            is_active
            fullname
            fullnamejobs
            user_info{
                firstname
                lastname
            }
            editable
            is_manager
            establishments
        }}
        """
    get_company_roles: (company_uid)->
        # console.log "GET COMPANY ROLES"
        return """
        query{company_role_set(company_uid:\"#{company_uid}\"){
            uid
            name
            profile_name
        }}
        """
    get_users_profile_company_roles: (company_uid, user_uid)->
        # console.log "GET COMPANY ROLES"
        return """
        query{users_profile_company_role_set(company_uid:\"#{company_uid}\", user_uid:\"#{user_uid}\"){
            uid
            name
            profile_name
        }}
        """
    get_company_roles_accesses: (company_uid)->
        # console.log "GET COMPANY ROLES ACCESSES"
        return"""
        query{roles_table_set(company_uid:\"#{company_uid}\"){
            access{
                uid
                group
                subgroup
                label
                name
                content
            }
            access_role_set{
                access_uid
                role_uid
                checked
            }
            group_line
        }}
        """
    get_interviews_requests_app_user_set: ()->
        # console.log "GET APP USERS"
        return """
        query{interviews_requests_app_user_set(is_archived:false){
            uid
            fullnamejobs
            job
            service_name
            ical
            user_info{
                lastname
                firstname
                phone
            }
            email
        }}
        """
    get_app_user_set: (company_uid, component)->
        # console.log "GET APP USERS"
        return """
        query{app_user_set(company_uid:\"#{company_uid}\", component:\"#{component}\"){
            uid
            fullnamejobs
            job
            service_name
            ical
            user_info{
                lastname
                firstname
                phone
            }
            email
        }}
        """
    get_contact_set: (company_uid)->
        # console.log "GET APP USERS"
        return """
        query{contact_set(company_uid:\"#{company_uid}\"){
            uid
            fullnamejobs
            job
            service_name
            ical
            user_info{
                lastname
                firstname
            }
            editable
            email
        }}
        """
    get_manager_set: (company_uid, user_uid)->
        # console.log "GET MANAGERS"
        return """
        query{manager_set(company_uid:\"#{company_uid}\", user_uid:\"#{user_uid}\"){
            uid
            fullnamejobs
        }}
        """
    get_user_access_set: ()->
        # console.log "GET USER ACCESS SET"
        return """
        query{user_access_set{
            label
        }}
        """
    get_company_billing_stats: ()->
        # console.log "GET COMPANY BILLING STATS"
        return """
        query{company_billing_stats{
            name
            distribution{
                distributed_by{
                    company{
                        name
                    }
                }
            }
            stats{
                dirigeant_profile_nb
                distributor_profile_nb
                employee_nb
                archived_employee_nb
                total_user_nb
            }
        }}
        """
    # Evaluation and EvalComment Query
    get_evaluation_set: (user_job_uid)->
        # console.log "GET EVALUATION"
        return """
        query{evaluation_set(user_job_uid:\"#{user_job_uid}\"){
            uid
            name
            date
            finished
            user_job{
                job{
                    name
                }
            }
            evaluator{
                uid
                fullname
            }
            evalcomment_set{
                text
            }
        }}
        """

    get_annuairegroupe_set: (company_uid)->
        # console.log "GET EVALUATION"
        return """
        query{annuairegroupe_set(company_uid:\"#{company_uid}\"){
            uid
            user{
                uid
                email
                service_name
                job
                fullname
                user_info{
                    firstname
                    lastname
                }
            }
            type {
                uid
                name
                company{
                    uid
                }
            }
        }}
        """
    get_annuairetypegroupe_set: (company_uid,user_uid)->
        # console.log "GET EVALUATION"
        return """
        query{annuairetypegroupe_set(company_uid:\"#{company_uid}\",user_uid:\"#{user_uid}\"){
            uid
           	name
            company{
              uid
            }
            user{
                uid
            }
        }}
        """
    get_besoins_en_formation_set: (user_job_uid)->
        # console.log "GET BESOINS_EN_FORMATION"
        return """
        query{besoins_en_formation_set(user_job_uid:\"#{user_job_uid}\"){
            uid
            date
            user_skill{
                uid
                user{
                    uid
                }
                skill{
                    uid
                    name
                }
                eval{
                    uid
                    name
                }
            }
        }}
        """
    run: (query_name, params)->
        self = @
        p = new Promise (resolve, reject)->
            if self[query_name]?
                q = self[query_name].apply(null, params)
                #console.log "Q : "+q
                Vue.http.post(settings.graphql_url, {query: q})
                .then (resp)->
                    resolve(resp)
                .catch (resp)->
                    reject(resp)
            else
                reject({body:{errors:[message:"Query "+query_name+" is not defined"]}})
        return p
}
